import React from 'react';
import { defineMessages } from 'react-intl';
import { generatePath, useLocation, useParams } from 'react-router-dom';
import PageWrapper from '@components/common/layout/PageWrapper';
import apiConfig from '@constants/apiConfig';
import { errorCodes } from '@constants/ErrorCode';
import useSaveBase from '@hooks/useSaveBase';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import DeviceForm from '@modules/digibesShop/Devices/tabs/kitplay/tabs/DeviceForm';
import routes from '@routes';
import { showErrorMessage } from '@services/notifyService';

const message = defineMessages({
    objectName: 'Device kitplay',
});

const DeviceSavePage = () => {
    const translate = useTranslate();
    const params = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const tab = queryParams.get('tab');
    const deviceId = queryParams.get('deviceId');
    const restaurantId = queryParams.get('restaurantId');
    const restaurantName = queryParams.get('restaurantName');
    const collapseId = queryParams.get('collapseId');
    const collapseParam = collapseId ? `&collapseId=${collapseId}` : '';

    const { detail, mixinFuncs, loading, setIsChangedFormValues, isEditing, title, setSubmit } = useSaveBase({
        apiConfig: {
            getById: apiConfig.kitplayDevice.getById,
            create: apiConfig.printer.create,
            update: apiConfig.printer.update,
        },
        options: {
            getListUrl: generatePath(routes.resDeviceTabsRestaurantListPage.path) + `?tab=${tab}&restaurantId=${restaurantId}&restaurantName=${restaurantName}${collapseParam}`,
            objectName: translate.formatMessage(message.objectName),
        },
        override: (funcs) => {
            funcs.prepareUpdateData = (data) => {
                return {
                    ...data,
                    id: detail.id,
                    parentId: deviceId,
                    restaurantId,
                };
            };
            funcs.prepareCreateData = (data) => {
                return {
                    ...data,
                    parentId: deviceId,
                    restaurantId,
                };
            };
            funcs.onSaveError = (err) => {
                const errorCode = err.response?.data?.code ?? err.code;
                const errorMessage = errorCodes[errorCode]?.message;
                if (errorMessage) {
                    showErrorMessage(translate.formatMessage(errorMessage), translate);
                    setSubmit(false);
                } else {
                    mixinFuncs.handleShowErrorMessage(err, showErrorMessage);
                    setSubmit(false);
                }
            };
        },
    });

    return (
        <PageWrapper
            loading={loading}
            routes={[
                {
                    breadcrumbName: translate.formatMessage(commonMessage.restaurant),
                    path: generatePath(routes.restaurantListPage.path),
                },
                {
                    breadcrumbName: restaurantName || translate.formatMessage(commonMessage.devices),
                    path: `${generatePath(routes.resDeviceTabsRestaurantListPage.path)}?tab=${tab}&restaurantId=${restaurantId}&restaurantName=${restaurantName}${collapseParam}`,
                },
                { breadcrumbName: title },
            ]}
            title={title}
        >
            <DeviceForm
                setIsChangedFormValues={setIsChangedFormValues}
                dataDetail={detail ? detail : {}}
                formId={mixinFuncs.getFormId()}
                isEditing={isEditing}
                actions={mixinFuncs.renderActions()}
                onSubmit={mixinFuncs.onSave}
            />
        </PageWrapper>
    );
};

export default DeviceSavePage;
